import { OrbType } from "../..";
export class ComboBombNormal {
    constructor(board, p1, p2, prng) {
        const cols = board.length;
        const rows = board[0].length;
        this.eliminatedOrbs = [];
        const orb1 = board[p1.c][p1.r];
        const orb2 = board[p2.c][p2.r];
        let color;
        let pBomb;
        if (orb1.type === OrbType.BOMB) {
            color = orb2.color;
            pBomb = p1;
            this.eliminatedOrbs.push({
                p: p1,
                type: OrbType.BOMB,
                n: 25,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        else {
            color = orb1.color;
            pBomb = p2;
            this.eliminatedOrbs.push({
                p: p2,
                type: OrbType.BOMB,
                n: 25,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        for (let c = 0; c < cols; c++) {
            for (let r = 0; r < rows; r++) {
                const orb = board[c][r];
                if (orb.color === color && orb.type !== OrbType.BOMB) {
                    const n = 5 + Math.floor(20 * prng.getRandom());
                    const orb = board[c][r];
                    this.eliminatedOrbs.push({
                        p: { c: c, r: r },
                        type: orb.type,
                        n: n,
                        triggeringOrbColor: null,
                        collapsing: false,
                        collapsingPosition: null,
                        isComboWrappedWrappedOrb: false,
                        pBomb: pBomb
                    });
                }
            }
        }
    }
    getEliminatedOrbs() {
        return this.eliminatedOrbs;
    }
    getSpecialOrbsAffected() {
        const specialOrbsAffected = [];
        for (let i = 0; i < this.eliminatedOrbs.length; i++) {
            const eliminatedOrb = this.eliminatedOrbs[i];
            if (eliminatedOrb.type === OrbType.STRIPPED_VER || eliminatedOrb.type === OrbType.STRIPPED_HOR || eliminatedOrb.type === OrbType.WRAPPED) {
                specialOrbsAffected.push(eliminatedOrb);
            }
        }
        return specialOrbsAffected;
    }
}
//# sourceMappingURL=data:application/json;base64,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